import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

const SIDEBAR_MINIMIZE_KEY = "sidebarMinimizeState";

@Component({
  selector: "app-vertical",
  templateUrl: "./vertical.component.html",
  styleUrls: ["./vertical.component.scss"]
})

/**
 * Vertical component
 */
export class VerticalComponent implements OnInit, AfterViewInit {
  @Input() isMenuVisible = false;

  constructor(private router: Router) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        document.body.classList.remove("sidebar-enable");
      }
    });
  }

  ngOnInit() {
    document.body.removeAttribute("data-layout");
    document.body.removeAttribute("data-topbar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("auth-body-bg");
    document.body.removeAttribute("data-sidebar-size");

    // Restore minimized state from localStorage
    const savedState = localStorage.getItem(SIDEBAR_MINIMIZE_KEY);
    if (savedState === "on") {
      document.body.classList.add("sidebar-minimized");
    }
  }

  isMobile() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  }

  ngAfterViewInit() {}

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
  }

  /**
   * On menu toggle button clicked
   */
  onToggleMobileMenu() {
    if (window.innerWidth <= 992) {
      document.body.classList.toggle("sidebar-enable");
    } else {
      const isMinimized = document.body.classList.toggle("sidebar-minimized");
      localStorage.setItem(SIDEBAR_MINIMIZE_KEY, isMinimized ? "on" : "off");
    }
  }
}
